import { api } from '../../../api';
import { entityPool } from '../../../core/engine/engine';
import { Member } from '../../../app/entities/member';

/**
 * Create member thunk
 */

type CreateMemberInput = {
  spaceId: string;
  members: Array<{
    email: string;
    role: 'admin' | 'creator' | 'guest';
  }>;
};

export const createMember = async ({ spaceId, ...input }: CreateMemberInput) => {
  const { data }: { data: Member[] } = await api.post(`/spaces/${spaceId}/members`, input);
  return data.map((el) => {
    const member = Object.assign(new Member(), el);
    entityPool.insert(member);
    return member;
  });
};
